<template>
  <!-- 搜索树 -->
  <div class="ds-control ds-index-bar" v-loading="loading" element-loading-text="加载中...">
    <div class="search-bar">
      <el-input v-model="searchName" class="search-input" suffix-icon="el-icon-search" placeholder="请输入姓名查询" />
    </div>
    <div class="side-bar">
      <span :title="data" v-for="data in sideBar" :key="data" @click="jumpIndex(data)" :class="{ active: data == activeSide }">{{ data }}</span>
    </div>
    <DsfVirtualScroll class="index-scroll-bar">
      <div class="index-bar">
        <div class="bar-list" v-if="showCheckAll">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" class="bar-checkbox-all">
            全选
          </el-checkbox>
          <el-checkbox-group v-model="checkedLists">
            <template v-for="(item, key) in listData">
              <template>
                <div class="anchor-index" :data-anchor="key" :key="key" :class="{ active: key == activeSide }" :ref="'anchor' + key">{{ key }}</div>
              </template>
              <template v-for="list in item">
                <el-checkbox :key="list.id" :label="list.id" class="hover" @change="(val) => handleCheckedListsChange(val, list)">
                  <div class="list">
                    <div>{{ list.name }}</div>
                    <div class="position-text ellipsis" v-if="list.positionText" :title="list.positionText">{{ list.positionText }}</div>
                  </div>
                </el-checkbox>
              </template>
            </template>
          </el-checkbox-group>
        </div>
        <div class="empty-data" v-else>暂无数据</div>
      </div>
    </DsfVirtualScroll>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfIndexBar",
  ctrlCaption: "通讯录",
  mixins: [$mixins.control],
  props: {
    name: {
      type: String,
      require: true,
    },
    apiAddress: {
      type: String,
      require: true,
    },
    smsData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      sideBar: "", // [A-Z]
      listData: {}, // 用于处理后的对象数据
      defaultListData: [], // 默认数据
      checkAll: false, // 全选
      checkedLists: [], // 当前选中值 [1,2]
      checkedItem: [], // 当前选中值 [{name:1},{name:2}] 提交数据
      isIndeterminate: false, // 用于实现全选的效果
      searchName: "", // 搜索
      searchData: [], // 搜索匹配的数据
      loading: false,
      // checkboxHidden: "", // 筛选的值
      activeSide: "", //默认选中key
      topArr: [], //滚动高度
      defaultProps: { children: "children", label: "name", otherName: false }, // 暂时无用
      showCheckAll: true,
    };
  },
  created() {
    // 获取树数据
    if (!this.apiAddress) {
      return;
    } else {
      if (this.apiAddress.length == 0) {
        return;
      }
    }
    this.initIndexBar();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
  },
  computed: {},
  methods: {
    onScroll() {
      const scrollBar = document.querySelectorAll(".index-scroll-bar .ds-virtual-scroll-box")[0];
      for (let i = 0; i < this.topArr.length; i++) {
        if (scrollBar?.scrollTop <= this.topArr[i].top + 40) {
          // 滚动距离判断应该滚动到第几个
          this.activeSide = this.topArr[i].key;
          break;
        }
      }
    },
    jumpIndex(key) {
      this.activeSide = key; // 当前导航
      const beforeTop = this.$refs["anchor" + key][0].getBoundingClientRect().top;
      const firstTop = document.querySelectorAll(".anchor-index")[0].getBoundingClientRect().top;
      const scrollBar = document.querySelectorAll(".index-scroll-bar .ds-virtual-scroll-box")[0];
      // 当前选择行距离顶部的高度 - 第一个高度 - 当前标签高度
      scrollBar.scrollTo({
        top: beforeTop - firstTop + 40,
        behavior: "smooth",
      });
    },
    handleCheckAllChange(status) {
      if (status) {
        // 是否搜索
        this.checkedItem = this.searchName ? _.uniq(_.concat(this.checkedItem, this.searchData)) : this.defaultListData.contactsUserTree;
        // 取id来选中lable值
        this.checkedLists = _.map(this.checkedItem, (item) => item.id);
      } else {
        if (this.searchName) {
          // 是否搜索  获取当前搜索列数据
          let searchList = _.map(this.searchData, (item) => item.id);
          //  右侧选择数据和 当前搜索筛选
          this.checkedItem = _.filter(this.checkedItem, (item) => {
            return _.indexOf(searchList, item.id) == -1;
          });
          // 取id来选中lable值
          this.checkedLists = _.map(this.checkedItem, (item) => item.id);
        } else {
          this.checkedItem = [];
          this.checkedLists = [];
        }
      }
      this.isIndeterminate = false;
      // 处理数据
      this.handleBack();
    },
    handleCheckedListsChange(status, list) {
      // 勾选数据做处理
      if (status) {
        this.checkedItem.push(list);
      } else {
        this.checkedItem = this.checkedItem.filter((item) => item.id != list.id);
      }
      // 处理数据
      this.handleBack();
      // 全选样式
      this.$nextTick(() => {
        this.checkedLists = _.map(this.checkedItem, (item) => item.id);
        let checkedCount = this.checkedItem.length;
        this.checkAll = checkedCount === this.defaultListData.contactsUserTree.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.defaultListData.contactsUserTree.length;
      });
    },
    handleBack() {
      if (this.$listeners["index-bar"]) {
        this.$dispatch("index-bar", this.checkedItem);
      } else {
        let peos = [];
        _.forEach(this.checkedItem, (item) => {
          peos.push({
            name: item.name,
            phone: item.phone,
            userTheirValue: item.pid,
            userTheirText: null,
            type: item.type,
            id: item.id,
          });
        });
        this.$emit("handle-add", this.name, peos);
      }
    },
    initIndexBar() {
      this.loading = true;
      this.$http
        .get(`${this.apiAddress}`)
        .done((re) => {
          if (re.success) {
            if (re.data.contactsUserTree && re.data.contactsUserTree.length) {
              this.sideBar = re.data.initialsList;
              this.defaultListData = re.data;
              this.listData = _.groupBy(this.defaultListData.contactsUserTree, "initials");
            } else {
              this.showCheckAll = false
            }
            this.loading = false;
            this.$nextTick(() => {
              const anchor = document.querySelectorAll(".anchor-index");
              for (let i = 0; i < anchor.length; i++) {
                let a = this.$refs["anchor" + anchor[0].innerText][0].getBoundingClientRect().top;
                this.topArr.push({
                  top: this.$refs["anchor" + anchor[i].innerText][0].getBoundingClientRect().top - a + 40,
                  key: anchor[i].innerText,
                });
              }
              // console.log("----", this.topArr);
            });
            // 回调给左边树回显
            this.$emit("call-back", this);
          } else {
            dsf.layer.message(re.message, false);
          }
        })
        .error((re) => {
          dsf.layer.message(re.message, false);
        });
    },
    // 筛选树中的内容
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  destroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  watch: {
    searchName(val) {
      if (val) {
        this.searchData = _.filter(this.defaultListData.contactsUserTree, (item) => {
          return item.name.indexOf(val) !== -1;
        });
        this.listData = _.groupBy(this.searchData, "initials");
        this.sideBar = _.keys(this.listData);
      } else {
        this.listData = _.groupBy(this.defaultListData.contactsUserTree, "initials");
        this.sideBar = _.keys(this.listData);
      }
      // 动态下全选
      let checkedCount = this.checkedItem.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.defaultListData.contactsUserTree.length;
      this.showCheckAll = !_.isEmpty(this.listData);
    },
  },
});
</script>
